import React from "react";
import { Card, Icon, Typography } from "../../index";
import PropTypes from 'prop-types';
import './file_attachment.scss';

export const FileAttachment = ({
    fileName,
    fileSize,
    onClick
}) => {

    const formatFileSize = (size) => {
        let toKB = Math.round(size / 1024);
        if (toKB >= 1024) {
            let toMB = (toKB / 1024).toFixed(2);
            return `${toMB} MB`
        }
        return `${toKB} KB`
    }
    return (
            <Card className={"bsw-file-attachment"}
                as={onClick ? 'button' : undefined}
                type={onClick ? 'button' : undefined}
                onClick={onClick}
            >
                <div className="bsw-file-attachment-wrapper">
                    <div className="icon-wrapper">
                        <Icon name="attachment" />
                    </div>
                    <div className="bsw-file-attachment-wrapper__content-file-name">
                        <Typography
                            bold
                            color={"$color-secondary-a2"}
                            type="heading-01"
                        >
                            {fileName}</Typography>
                    </div>
                    <div className="bsw-file-attachment-wrapper__content-file-size">
                        <Typography
                            color={"$color-secondary-a3"}
                            type="heading-01"
                        >{formatFileSize(fileSize)}</Typography>

                    </div>

                </div>

                {onClick &&
                    <div className="bsw-file-attachment__button--remove" ><Typography
                        bold
                        color={"$color-primary-a3"}
                        type="cta-03"
                    >
                        Remove
                    </Typography></div>
                }

            </Card>
    );
       
};



FileAttachment.propTypes = {
    fileName:PropTypes.string,
    fileSize: PropTypes.number,
    onClick:PropTypes.func
}